import React from 'react';
import { createRoot  } from 'react-dom/client';
import './index.css';
import 'devextreme/dist/css/dx.material.blue.light.css';
import App from './App';
import config from "devextreme/core/config";
import { licenseKey } from "./devextreme-license";
import { locale, loadMessages } from "devextreme/localization";
import { getLocale, languageDictionaries } from "./i18n";
import nbMessages from "./nb-devextreme.json"

config({ licenseKey });

loadMessages(nbMessages);
loadMessages(languageDictionaries);

locale(getLocale());

const container = document.getElementById('root');

if (container === null)
  throw new Error("Root container for React app does not exist");

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
